module.exports = __webpack_public_path__ + "img/Ausgefüllter_Raum_Wasser.72319ff7.svg";